import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect, useMemo, useRef } from 'react';
import InventoryContext from '~/context/srp/InventoryContext';

export default function useLogMissingConditionalTiles() {
  const inventoryContext = useContext(InventoryContext);

  // Safely extract data with null checks using useMemo to prevent dependency changes
  const inventory = inventoryContext?.inventory?.data?.inventory;
  const conditionalTiles = useMemo(
    () => inventory?.conditionalTiles || [],
    [inventory?.conditionalTiles]
  );
  const vehicles = useMemo(
    () => inventory?.vehicles || [],
    [inventory?.vehicles]
  );
  const searchRequestId = inventoryContext?.inventory?.data?.searchRequestId;

  const loggedSearchRequestId = useRef('');

  useEffect(() => {
    if (loggedSearchRequestId.current === searchRequestId) return;

    // Only log when we have vehicles but no conditional tiles
    if (conditionalTiles.length === 0 && vehicles.length > 0) {
      datadogRum.addAction('SRP Missing Conditional Tiles', {
        searchRequestId
      });

      loggedSearchRequestId.current = searchRequestId;
    }
  }, [conditionalTiles, searchRequestId, vehicles]);
}
